// extracted by mini-css-extract-plugin
module.exports = {"linksContainer":"style_linksContainer__KnoGo","item":"style_item__1u2o_","logo":"style_logo__39ufM","link":"style_link__2V3xe"};